/* Suprafeel · /pages/preguntas-frecuentes — behaviour ported from src/routes/preguntas-frecuentes (spy.ts,
   S00PfStickyNav, S01PfSection).
   - scroll-spy: each [data-pf-cat] observed with rootMargin -30% 0 -60%; the last one entering the band is active.
     A click scrolls the category into view, activates it at once and pauses the spy until scrolling is idle 150ms.
   - ≤991 strip: active item black, 1px underline slides to it, strip scrolls to centre it.
   - accordions: single-open per category; panel max-height 0 → scrollHeight, content fades in 100ms later. */
(function () {
  function init(root) {
    if (!root || root.__sfwPf) return;
    root.__sfwPf = true;

    var cats = [].slice.call(root.querySelectorAll('[data-pf-cat]'));
    var strip = root.querySelector('[data-sfw-pf-strip]');
    var line = root.querySelector('[data-sfw-pf-line]');
    var active = 0;
    var locked = false;
    var idle = null;

    function place() {
      if (!strip || !line) return;
      var a = strip.querySelector('[data-sfw-pf-go="' + active + '"]');
      if (!a) return;
      line.style.transform = 'translateX(' + a.offsetLeft + 'px)';
      line.style.width = a.offsetWidth + 'px';
      if (strip.clientWidth) strip.scrollTo({ left: a.offsetLeft + a.offsetWidth / 2 - strip.clientWidth / 2, behavior: 'smooth' });
    }

    function set(i) {
      active = i;
      [].forEach.call(root.querySelectorAll('[data-sfw-pf-go]'), function (a) {
        a.classList.toggle('is-active', Number(a.getAttribute('data-sfw-pf-go')) === i);
      });
      place();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (locked) return;
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = Number(e.target.getAttribute('data-pf-cat'));
          if (i >= 0 && i !== active) set(i);
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      cats.forEach(function (c) { io.observe(c); });
    }

    function onIdle() {
      if (idle) clearTimeout(idle);
      idle = setTimeout(function () {
        locked = false;
        window.removeEventListener('scroll', onIdle);
      }, 150);
    }

    root.addEventListener('click', function (e) {
      var go = e.target.closest('[data-sfw-pf-go]');
      if (go) {
        e.preventDefault();
        var i = Number(go.getAttribute('data-sfw-pf-go'));
        var el = root.querySelector('[data-pf-cat="' + i + '"]');
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        set(i);
        locked = true;
        window.addEventListener('scroll', onIdle, { passive: true });
        onIdle();
        return;
      }

      var btn = e.target.closest('.sfw-pf-btn');
      if (!btn) return;
      var item = btn.closest('[data-sfw-pf-item]');
      var group = item.closest('[data-pf-cat]');
      var wasOpen = item.classList.contains('is-open');
      [].forEach.call(group.querySelectorAll('[data-sfw-pf-item]'), function (it) {
        var content = it.querySelector('.sfw-pf-content');
        clearTimeout(it.__t);
        content.classList.remove('is-shown');
        if (it !== item || wasOpen) {
          it.classList.remove('is-open');
          it.querySelector('.sfw-pf-btn').setAttribute('aria-expanded', 'false');
          it.querySelector('.sfw-pf-panel').style.maxHeight = '0px';
        }
      });
      if (!wasOpen) {
        var content = item.querySelector('.sfw-pf-content');
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        item.querySelector('.sfw-pf-panel').style.maxHeight = content.scrollHeight + 'px';
        item.__t = setTimeout(function () { content.classList.add('is-shown'); }, 100);
      }
    });

    place();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    window.addEventListener('resize', place);
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-sfw-pf]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
